<!-- eslint-disable vue/multi-word-component-names -->
<script lang="ts" setup>
import { RouterView, useRoute } from "vue-router";
import LayoutMain from "@/components/v2/Layouts/LayoutMain.vue";
import { TasksService } from "@/services/v2/tasks";
import { useTasksStore } from "@/stores/v2";
import { normalizeRouteParam } from "@/utils/v2/routes";
import { onMounted } from "vue";
import { useTask } from "@/composables/tasks/useTask";
import TaskDependencyWarningModal from "@/components/v2/Tasks/Task/TaskDependencyWarningModal.vue";

const { startObserver } = useTask();

const route = useRoute();
const taskKey = normalizeRouteParam(route.params.key)

const init = async () => {
    const task = await TasksService.startTask(taskKey);
    if (!task) return;

    await useTasksStore().setActiveTask(task);
    startObserver();
};

onMounted(() => {
    init();
});
</script>

<template>
    <LayoutMain>
        <template #mainArea>

            <TaskDependencyWarningModal />
            <RouterView />
        </template>
    </LayoutMain>
</template>
